(function() {
    'use strict';

    module.exports = {
        isGRecaptchaLoaded: false,
        isGRecaptchaInit: false,

        init: function() {
            if (!this.isGRecaptchaInit) {
                window.grecaptchaloaded = Odigeo._.bind(this.gRecaptchaLoaded, this);
                Odigeo.require(['recaptcha']);
                this.isGRecaptchaInit = true;
            }
        },

        gRecaptchaLoaded: function() {
            this.isGRecaptchaLoaded = true;
            Odigeo.trigger('recaptcha:loaded');
        },

        gRecaptchaRender: function(item, callback, sitekey) {
            var widgetId = window.grecaptcha.render(item, {
                'sitekey': sitekey,
                'badge': 'inline',
                'size': 'invisible',
                'theme': 'light',
                'callback': callback,
                'error-callback': Function.prototype,
                'expired-callback': Function.prototype,
            });
            return widgetId;
        },

        gRecaptchaExecute: function(widgetID) {
            window.grecaptcha.execute(widgetID);
        },

        gRecaptchaGetResponse: function(widgetID) {
            return window.grecaptcha.getResponse(widgetID);
        },

        gRecaptchaReset: function(widgetID) {
            if (!Odigeo._.isUndefined(widgetID)) {
                window.grecaptcha.reset(widgetID);
            }
        },
    };
}());
